import SubmissionModal from './SubmissionModal';

export default SubmissionModal;
